module.exports = __webpack_public_path__ + "static/media/BBVA.fbfe411c.png";